/**
 * Hides content until you click on a link to reveal it
 */
function initReadMore()
{
    const defaultMaxHeight = 200;
    const cssClass = 'read-more';
    const cssClassOpen = 'read-more--open';
    const cssClassTrigger = 'read-more__trigger';

    let allElements = document.querySelectorAll('.js-read-more');

    // ie11 workaround: convert NodeList to Array, couldn't solve it with babel
    allElements = Array.prototype.slice.call(allElements);

    allElements.forEach((element) =>
    {
        let content = element.querySelector('.js-read-more__content');

        // Get translations from data elements (data-text-read-more, data-text-read-less)
        let textOpen = 'open';
        let textClose = 'close';

        if ('readMoreOpenText' in element.dataset)
        {
            textOpen = element.dataset.readMoreOpenText;
        }

        if ('readMoreCloseText' in element.dataset)
        {
            textClose = element.dataset.readMoreCloseText;
        }

        // Get max height from data attribute (data-read-more-height)
        let maxHeight = defaultMaxHeight;

        if ('readMoreMaxHeight' in element.dataset)
        {
            maxHeight = element.dataset.readMoreMaxHeight;
        }

        // Check if the text is too high and if 'read more' is already applied
        if (element.clientHeight > maxHeight && !content.classList.contains(cssClass))
        {
            content.classList.add(cssClass);
            content.style.maxHeight = maxHeight + 'px';

            let triggerIcon = document.createElement('i');
            triggerIcon.classList.add('fa-regular', 'fa-angle-down', 'read-more__icon');

            let triggerText = document.createElement('span');
            triggerText.innerText = textOpen;

            let trigger = document.createElement('button');
            trigger.classList.add(cssClassTrigger, 'display-link');
            trigger.appendChild(triggerText);
            trigger.appendChild(triggerIcon);

            trigger.addEventListener('click', (event) =>
            {
                event.preventDefault();

                content.classList.toggle(cssClassOpen);

                // Toggle button texts
                if (content.classList.contains(cssClassOpen))
                {
                    triggerText.innerText = textClose;
                }
                else
                {
                    triggerText.innerText = textOpen;
                }
            });

            element.appendChild(trigger);
        }
    });
}

initReadMore();

